import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'What documents do I need for Umrah or Hajj?',
      answer: 'You will need a valid passport (with at least 6 months validity), visa, vaccination certificates (including meningitis and COVID-19), and travel insurance. Our team will guide you through the complete documentation process and assist with visa applications.'
    },
    {
      question: 'When is the best time to perform Umrah?',
      answer: 'Umrah can be performed at any time of the year. However, Ramadan is considered the most blessed time. We offer packages throughout the year, with special Ramadan packages available. Peak seasons may have higher prices due to increased demand.'
    },
    {
      question: 'What is included in the package price?',
      answer: 'Package prices include return flights, accommodation, ground transportation, Ziyarat tours, and guide services. Meals are included as specified in each package. Personal expenses, additional tours, and optional services are not included unless stated.'
    },
    {
      question: 'How close are the hotels to Haram?',
      answer: 'We prioritize proximity to Haram for your convenience. Our 3-star hotels are typically within 500-800 meters, 4-star hotels within 300-500 meters, and 5-star hotels offer walking distance or direct Haram views. Exact distances are confirmed at booking.'
    },
    {
      question: 'Can I customize my package?',
      answer: 'Absolutely! We understand every traveler has unique needs. Our advisors can customize your itinerary, extend your stay, upgrade accommodations, or add special services. Contact us to discuss your requirements and receive a personalized quote.'
    },
    {
      question: 'What is your cancellation policy?',
      answer: 'Cancellation terms vary by package and booking date. Generally, deposits are non-refundable. Cancellations made 60+ days before departure may receive partial refunds. We strongly recommend travel insurance to protect against unforeseen circumstances.'
    },
    {
      question: 'Do you provide group discounts?',
      answer: 'Yes, we offer special rates for groups of 10 or more travelers. Group bookings also benefit from dedicated group coordinators and customized services. Contact our team for a tailored group package quote.'
    },
    {
      question: 'What support is available during the journey?',
      answer: 'Our experienced guides accompany you throughout the journey, providing religious guidance and practical assistance. We also have 24/7 customer support available via phone and WhatsApp for any emergencies or queries during your trip.'
    }
  ];

  return (
    <section className="py-24 bg-[#FAF8F5]">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-[#C9A961] text-lg mb-4 italic" style={{ fontFamily: 'Playfair Display, serif' }}>
            /Common Questions
          </p>
          <h2 className="text-5xl lg:text-6xl font-bold text-[#3A2F2B] mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600">
            Find answers to the most common questions about our Umrah and Hajj packages
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left cursor-pointer hover:bg-gray-50 transition-colors"
              >
                <h3 className="text-lg font-bold text-[#1A1F2E] pr-8">{faq.question}</h3>
                <i className={`ri-arrow-down-s-line text-2xl text-[#C9A961] transition-transform duration-300 flex-shrink-0 ${
                  openIndex === index ? 'rotate-180' : ''
                }`}></i>
              </button>
              
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-8 pb-6">
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center p-8 bg-white rounded-2xl">
          <h3 className="text-2xl font-bold text-[#1A1F2E] mb-4">Still have questions?</h3>
          <p className="text-gray-600 mb-6">
            Our travel advisors are here to help you with any queries about your pilgrimage
          </p>
          <button 
            onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
            className="px-8 py-3 bg-[#C9A961] text-white rounded-lg text-base font-semibold hover:bg-[#B89951] transition-all whitespace-nowrap cursor-pointer"
          >
            Contact Our Team
          </button>
        </div>
      </div>
    </section>
  );
}
